"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSWRDefaultKey = void 0;
var swr_1 = __importDefault(require("swr"));
function getAspidaSWRDefaultKey(api, maybeMethod) {
    var option = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        option[_i - 2] = arguments[_i];
    }
    var method = typeof maybeMethod === 'string' ? maybeMethod : '$get';
    var opt = typeof maybeMethod === 'string' ? option[0] : maybeMethod;
    return [api.$path(opt), method];
}
exports.getSWRDefaultKey = getAspidaSWRDefaultKey;
function useAspidaSWR(api, maybeMethod) {
    var _a;
    var option = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        option[_i - 2] = arguments[_i];
    }
    var method = typeof maybeMethod === 'string' ? maybeMethod : '$get';
    var opt = typeof maybeMethod === 'string' ? option[0] : maybeMethod;
    var enabled = (_a = opt === null || opt === void 0 ? void 0 : opt.enabled) !== null && _a !== void 0 ? _a : true;
    var key = (opt === null || opt === void 0 ? void 0 : opt.key) !== undefined
        ? typeof opt.key === 'function'
            ? opt.key()
            : opt.key
        : enabled
            ? getAspidaSWRDefaultKey(api, method, opt)
            : null;
    var fetcherInterv = (opt === null || opt === void 0 ? void 0 : opt.fetcher) === undefined ? (enabled ? function (f) { return f; } : null) : opt === null || opt === void 0 ? void 0 : opt.fetcher;
    var fetcher = !api || typeof fetcherInterv !== 'function'
        ? null
        : (function (api) { return function () {
            return fetcherInterv(api[method])(opt);
        }; })(api);
    return (0, swr_1.default)(key, fetcher, opt);
}
exports.default = useAspidaSWR;
//# sourceMappingURL=index.js.map